
@if (!customizableMode) {
  <p-card>
    <div class="padding15" style="position:relative;">
      @if (!ps.hasAnyRole(['ROLE_MODEL_SEC_MANAGER'])) {
        @if (!ps.hasAnyRole(['ROLE_MODEL_SEC_MANAGER'])) {
<div style="
              position: absolute;
              top: 0;
              bottom: 0;
              width: 100%;
              opacity: 0.5;
              background-color: white;
              height: 100%;">
          </div>
        }
      }
      <div style="display: flex;flex-direction: row;">
        <div class="module-title">
          <div class="module-title-label" >Top Models</div>
          <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showModels()" >
        </div>
      </div>

      @if (!data) {
        <div class='loading-spinner'></div>
      }

      @if (singleWidth && data) {
        <div class="module-models-horizontal-bar">
          @for (percentage of percentages; track percentage; let i = $index) {
            @if (percentage > 0.2) {
              <div [style.backgroundColor]="colors[i]" [style.width]="(percentage-0.2)+'%'" class="module-models-horizontal-bar-item"></div>
            }
          }
          @if (!percentages.length) {
            <div class="module-models-horizontal-bar-item" style="background-color: #CECECE;width: 100%;"></div>
          }
        </div>

        <ng-container [ngTemplateOutlet]="moduleModelsTableTemplate"></ng-container>
      }

      @if (!singleWidth && data) {
        <div class="module-div-includes-charts">
          <div class="module-div-chart-wrap">
            <p-chart type="doughnut" [data]="chartData" [options]="options" width="176px" height="176px"></p-chart>
          </div>
          <ng-container [ngTemplateOutlet]="moduleModelsTableTemplate"></ng-container>
        </div>
      }
    </div>
  </p-card>
}

<ng-template #moduleModelsTableTemplate>

  <div [class.models-module-table-double-view]="!singleWidth" [class.models-module-table-single-view]="singleWidth" style="width: 100%;">
    <div class="models-module-table-header">
      <div class="models-module-table-col1" style="padding-left: 18px;">Model Name</div>
      <div class="models-module-table-col2">Portfolios</div>
      <div class="models-module-table-col3">AUM</div>
      <div class="models-module-table-col4"></div>
    </div>
    @for (item of data.topModels; track item.modelId; let i = $index) {
      <div class="models-module-table-row">
        <div class="models-module-table-col1 truncate" tooltip [tooltipTitle]="item.modelName" [tooltipRequiresTruncation]="true" tooltipPosition="right" [tooltipHorizontalOffset]="0">
          <div class="module-model-column-name" [style.backgroundColor]="colors[i]"></div>{{item.modelName}}
        </div>
        <div class="models-module-table-col2">{{item.portfolioCount}}</div>
        <div class="models-module-table-col3">${{item.aum | number}}</div>
        <div class="models-module-table-col4">
          @if (singleWidth) {
            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" style="width: 16px;" (click)="showModelDetail(item.modelId, item.modelName)">
          }
          @else {
          <a (click)="showModelDetail(item.modelId, item.modelName)">View</a>
        }
      </div>
    </div>
  }
  @for (item of data.remainingModels; track item) {
    <div class="models-module-table-row">
      <div class="models-module-table-col1">
        <div class="module-model-column-name" [style.backgroundColor]="colors[5]"></div>Other
      </div>
      <div class="models-module-table-col2">{{item.portfolioCount}}</div>
      <div class="models-module-table-col3">${{item.aum | number}}</div>
      <div class="models-module-table-col4"></div>
    </div>
  }
</div>

</ng-template>

@if (customizableMode) {
  @if (singleWidth) {
    <div style="padding:0 10px;">
      <div class="module-models-horizontal-bar" style="margin-bottom: 20px;padding-top:25px;margin-top:0;">
        @for (percentage of percentagesSkeleton; track percentage; let i = $index) {
          <div [style]="{'width':(percentage)+'%', 'backgroundColor': customizeColors[i]}" class="module-models-horizontal-bar-item"></div>
        }
      </div>

      <ng-container [ngTemplateOutlet]="moduleSkeletonModelsTableTemplate"></ng-container>
    </div>
  }

  @if (!singleWidth) {
    <div style="display: flex;flex-direction: row;height: 100%;align-items: center;padding-bottom: 15px;padding-right: 10px;">
      <div style="height:176px;width: 176px;margin-left: 10px;">
        <img src="../../assets/images/donut-skeleton-md.svg" style="cursor: inherit!important;">
      </div>
      <div style="margin-left: 30px;width:95%;">
        <ng-container [ngTemplateOutlet]="moduleSkeletonModelsTableTemplate"></ng-container>
      </div>
    </div>
  }


}
<ng-template #moduleSkeletonModelsTableTemplate>
  <table>
    <tr>
      <td style="width: 35%;">
        <div style="display: flex;flex-direction: row;">
          <div style="width:18px;"></div>
          <div class="skeleton-styles-rectangle" style="width: 99%;"></div>
        </div>
      </td>
      <td style="width: 25%;"><div class="skeleton-styles-rectangle" style="width: 85%;"></div></td>
      <td style="width: 40%;">
        <div class="module-flex-row-with-space">
          <div style="width: 80%; justify-content: flex-end;display: flex;">
            <div class="skeleton-styles-rectangle" style="width: 30%;"></div>
          </div>
          <div></div>
        </div>
      </td>
    </tr>
    @for (y of [].constructor(6); track $index; let i = $index) {
      <tr>
        <td>
          <div style="display: flex;flex-direction: row;">
            <div [style]="{'backgroundColor': customizeColors[i]}" style="background-color: #C6CDD2;width: 12px;height: 12px; margin: 2px 5px 2px 0;"></div>
            <div class="skeleton-styles-rectangle" [style.width.%]="modelNameRandom[i]"></div>
          </div>
        </td>
        <td ><div class="skeleton-styles-rectangle" [style.width.%]="portfoliosRandom[i]"></div></td>
        <td >
          <div class="module-flex-row-with-space">
            <div style="width: 80%; justify-content: flex-end;display: flex;">
              <div class="skeleton-styles-rectangle" [style.width.%]="aumRandom[i]"></div>
            </div>
            @if (singleWidth) {
              <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
            }
            @if (!singleWidth) {
              <div class="skeleton-styles-rectangle" style="width:30px;"></div>
            }
          </div>
        </td>
      </tr>
    }
  </table>
</ng-template>


